import { Button, Icon, Input, Text } from ".";
import { useEffect, useState } from "react";

import MuiDropdown from "./MuiDropdown";
import { colors } from "app/utils/theme";
import { get } from "lodash";
import styled from "styled-components";

const SimpleDropdown = ({ data }) => {
  const darkMode = get(data, "darkMode");

  const [expanded, setExpanded] = useState(false);

  const [closeCounter, setCloseCounter] = useState(0);

  const showOnHover = false;

  const noIcon = get(data, "noIcon");

  const optionFontStyle = get(data, "optionFontStyle", "bodyMd");

  const [filteredOptions, setFilteredOptions] = useState(data.options);

  const getTriggerComponent = () => {
    if (data.component) {
      return data.component;
    }

    if (data.text) {
      return <Text data={data.text} />;
    }

    if (data.icon) {
      return <Icon data={data.icon} />;
    }

    if (data.button) {
      return (
        <Button
          data={{
            ...data.button,
            icon:
              data.button.icon || (expanded ? "FiChevronUp" : "FiChevronDown"),
          }}
        />
      );
    }
  };

  const handleSearchChange = (value, options) => {
    const searchQuery = value.toLowerCase();
    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(searchQuery)
    );
    setFilteredOptions(filtered);
  };

  useEffect(() => {
    setFilteredOptions(data.options);
  }, [data.options]);

  return (
    <Container
      onMouseEnter={() => {
        if (showOnHover) {
          setExpanded(true);
        }
      }}
      onMouseLeave={() => {
        if (showOnHover) {
          setExpanded(false);
        }
      }}
    >
      <MuiDropdown
        triggerComponent={getTriggerComponent()}
        setExpanded={setExpanded}
        closeCounter={closeCounter}
        background={darkMode ? colors.darkModeInputBackground : "white"}
        style={{ borderRadius: "100px" }}
        darkMode={darkMode}
      >
        {data.headerComponent}
        <OptionsContainer>
          {data.showSearch && (
            <Input
              data={{
                border: "0px",
                placeholder: "Search",
                padding: "5px",
                onChange: (value) => handleSearchChange(value, data.options),
              }}
            />
          )}
          {filteredOptions.map((option, i) => {
            const icon = get(option, ["data", "icon"]) || get(option, "icon");
            return (
              <Option
                id={`simpleDropdown-option-${i}`}
                key={i}
                darkMode={darkMode}
                background={
                  darkMode
                    ? colors.darkModeLightBackground
                    : option.active && colors.grey2
                }
                padding={data.optionPadding}
                minWidth={data.optionMinWidth}
                onClick={(e) => {
                  option.onClick(e);
                  setCloseCounter(closeCounter + 1);
                }}
              >
                {icon && !noIcon && (
                  <Icon
                    data={{
                      icon,
                      color: darkMode ? "white" : "var(--grey8)",
                      size: 18,
                      hover: true,
                    }}
                  />
                )}
                <Text
                  data={{
                    text: option.label,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    fontStyle: optionFontStyle,
                    color: darkMode ? "white" : colors.default,
                  }}
                />
              </Option>
            );
          })}
        </OptionsContainer>
      </MuiDropdown>
    </Container>
  );
};

export default SimpleDropdown;

const Container = styled.div`
  position: relative;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
`;

const Option = styled.div`
  font-size: 16px;
  padding: 10px 12px 10px 12px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  border-radius: 8px;
  min-width: ${(p) => p.minWidth || "fit-content"};
  align-items: center;
  background: ${(p) => p.background};
  &:hover {
    background: ${(p) =>
      p.darkMode ? colors.darkModeInputBackground : colors.clickUpBackground};
  }
`;
